// extracted by mini-css-extract-plugin
export default {"modal":"ModalComponent_modal__MGEbn","modal__close-btn":"ModalComponent_modal__close-btn__iaTR3","privacyContent":"ModalComponent_privacyContent__i5v1W"};